import { useCallback, useEffect, type FunctionComponent } from "react";
import { Outlet, useParams, useSearchParams } from "react-router-dom";
import { useSearchPostsAdminHttp } from "../../../../hooks/http/admin/posts/search-posts.admin.http";
import { debounce, handleHttpError } from "../../../../utils/utils";
import { useToast } from "../../../../hooks/use-toast";
import Spinner from "../../../../components/spinner.components";
import usePostStore from "../../../../store/post.store";
import { CampaignPostAdminPartial } from "./campaign-post.admin.partials";
import type { IPost } from "../../../../types/models/post.models.types";

const CampaignPostSearchAdminPartial: FunctionComponent = () => {
  const [search] = useSearchParams();
  const { campaignId } = useParams();
  const { execute: searchPostsHttp, fetching: searching } =
    useSearchPostsAdminHttp();

  const { toast } = useToast();
  const { setData, data: postStore } = usePostStore();

  const debouncedPostSearch = useCallback(
    debounce(async (searchValue: string) => {
      if (searchValue.trim().length < 4) return;
      if (!campaignId) return;

      const response = await searchPostsHttp({
        body: null,
        queryParams: {
          campaign: campaignId,
          searchString: searchValue,
        },
      });
      if (!response.success) {
        return handleHttpError(response, toast);
      }
      setData(response.data.posts);
    }, 500),
    []
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (search.get("query")) {
      setData([]);
      debouncedPostSearch(search.get("query") ?? "");
    }
  }, [search.get("query")]);

  console.log(search.get("query"));
  return (
    <div className="flex flex-col w-full">
      <div className="py-16 w-full font-semibold text-3xl">Search results:</div>
      {searching ? (
        <div className="flex justify-center items-center h-96">
          <Spinner />
        </div>
      ) : (
        <div className="gap-6 grid grid-cols-3">
          {postStore.map((post: IPost) => (
            <CampaignPostAdminPartial key={post.id} post={post} />
          ))}
        </div>
      )}
      {!postStore.length && !searching && (
        <div className="flex justify-center items-center h-96">
          No posts found
        </div>
      )}
      <Outlet />
    </div>
  );
};

export default CampaignPostSearchAdminPartial;
